import { motion } from 'motion/react';
import styled from 'styled-components';

import breakpoints, { under } from '@polyai/ui/styles/config/breakpoints';
import themeColors from '@polyai/ui/styles/config/colors';
import sizes from '@polyai/ui/styles/config/sizes';
import themeSpacing from '@polyai/ui/styles/config/spacing';
import text from '@polyai/ui/styles/config/text';

import PolyaiLogoSlate from 'assets/svg/companyLogos/polyai-logo-slate-rgb.svg';
import PolyaiLogoWhite from 'assets/svg/companyLogos/polyai-logo-white-rgb.svg';
import { ContentContainer as BaseContentContainer } from '../../AgentWizard.styled';

export const ContentContainer = styled(BaseContentContainer)`
  height: 100%;
`;

export const RightPanel = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 1.5rem;

  background: ${themeColors.background};
`;

export const FormWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;

  width: clamp(260px, 92vw, ${sizes.wizardContentWidth}px);
`;

export const Form = styled.div`
  display: grid;
  gap: ${themeSpacing.sm2};
  width: 100%;
`;

export const Title = styled.h2`
  margin: 0;

  font-size: ${text.size.header.large};
  font-weight: ${text.weight.semibold};
  line-height: 1.2;
  color: ${themeColors.textPrimary};
`;

export const Description = styled.p`
  margin: 0 0 ${themeSpacing.sm1};
  font-size: ${text.size.body.regular};
  line-height: 1.5;
  color: ${themeColors.textSecondary};
`;

export const ButtonWrapper = styled.div`
  margin-top: ${themeSpacing.xs3};
`;

export const Actions = styled.div`
  display: flex;
  gap: ${themeSpacing.xs3};
  align-items: center;
  margin-top: ${themeSpacing.xs2};
`;

export const Logo = styled(PolyaiLogoWhite)`
  position: absolute;
  top: ${themeSpacing.sm3};
  left: ${themeSpacing.sm3};
  transform: translateZ(0);

  display: block;

  width: auto;
  height: ${themeSpacing.sm4};

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: geometricprecision;

  shape-rendering: geometricprecision;
`;

export const MobileLogo = styled(PolyaiLogoSlate)`
  position: absolute;
  top: ${themeSpacing.sm3};
  left: ${themeSpacing.sm3};
  transform: translateZ(0);

  display: none;

  width: auto;
  height: ${themeSpacing.sm4};

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: geometricprecision;

  shape-rendering: geometricprecision;

  @media ${under(breakpoints.sm)} {
    display: none; /* Hide on small screens to avoid overlap with progress slider */
  }
`;

export const LoadingContainer = styled.div`
  display: grid;
  gap: ${themeSpacing.xs2};
  place-items: center;
  min-height: 60vh;
`;

export const LoadingText = styled.div`
  font-size: ${text.size.header.large};
  font-weight: ${text.weight.semibold};
  line-height: 1.2;
`;

export const ShimmerText = styled(motion.div)`
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  color: transparent;

  background: linear-gradient(
    90deg,
    ${themeColors.textShimmerDark},
    ${themeColors.textShimmerMid},
    ${themeColors.textShimmerLight}
  );
  background-clip: text;
  background-size: 200% 100%;
`;
